// extracted by mini-css-extract-plugin
export default {"styledScreen":"matchedScreen_styledScreen__0vm7z","styledTitle":"matchedScreen_styledTitle__qinI9"};